import { signal } from "@preact/signals-react"

export const passwordSettingsSignal = signal([])
export const passwordSettingsErrorSignal = signal(null)
export const passwordSettingsLoadedSignal = signal(false)